var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Animal = function() {
    EHDI.aka.Container.call(this);
};

EHDI.game.Animal.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Animal.prototype.init = function (spawnData, callback, snake, despawnDelay) {
  this._hitbox;
  this._callback = callback;
  this._spawnData = spawnData;
  this._isSnake = snake;
  this._imagePath;
  this._imageTexture;
  this._imageSprite;
  this._startingPos;
  this._destinationPos;
  this._timer;
  this._despawnDelay = despawnDelay;
  this._warningDelay = despawnDelay * 0.5;
  this._warningEnable = false;
  this._removed = false;
  this._tapped = false;
  this._stopped = false;
  this._shake = false;
  this._shakeLeft = true;
  this._shakeUp = true;
  this._currentX;
  this._currentY;

  this.willDisappear = false;

  if (this._timer == null) {
    this._timer = new EHDI.util.Time();
  }

  if (this._startingPos == null) {
    this._startingPos = {x:0, y:0};
  }

  if (this._destinationPos == null) {
    this._destinationPos = {x:0, y:0};
  }

  this._startingPos.x = 0;
  this._startingPos.y = 0;
  this._destinationPos.x = 0;
  this._destinationPos.y = 0;

  if (this._hitbox == null) {
    this._hitbox = new EHDI.game.Hitbox(80, 80, 70, 70, 0x00000000);
    this._hitbox.alpha = 0;

    this.addChild(this._hitbox);

    this._hitbox.interactive = true;
    this.onTouchWithBind = this._handler_onTouch.bind(this);
    this._hitbox.on('pointerdown', this.onTouchWithBind);
  }

  this.initAnimalImg();

  this.alpha = 0;

  if (this._startingPos.x != 0)
    this._startingPos.x += spawnData.x;
  else
    this._startingPos.x = spawnData.x + this._destinationPos.x;

  if (this._startingPos.y != 0)
    this._startingPos.y += spawnData.y;
  else
    this._startingPos.y = spawnData.y + this._destinationPos.y;

  this.x = this._startingPos.x;
  this.y = this._startingPos.y;

  this.tl1 = TweenLite.to(this, 0.1,
  {alpha:1, x:spawnData.x + this._destinationPos.x, y:spawnData.y + this._destinationPos.y, ease:Power0.easeIn});

  this._timer.reset();
};

EHDI.game.Animal.prototype.animateOut = function () {
  this.emit('REMOVE_WARNING', this._spawnData.x, this._spawnData.y, this._isSnake);

  this.tl1 = TweenLite.to(this, 0.06, {alpha:0, x:this._startingPos.x, y:this._startingPos.y,
  ease:Power0.easeIn});
};

EHDI.game.Animal.prototype.shake = function () {
  this._shake = true;

  this._currentX = this.x;
  this._currentY = this.y;
};

EHDI.game.Animal.prototype.initAnimalImg = function () {
  this._destinationPos.x = 0;
  this._destinationPos.y = 0;

  if (this._isSnake) {
    var randomNumber = Math.floor(Math.random() * 6);

    if (randomNumber == 0) {
      this._imagePath = 'snake_hit01';
      this._startingPos.x = -30;
      this._startingPos.y = 50;
      this._destinationPos.y = 20;
    } else if (randomNumber == 1) {
      this._imagePath = 'snake_hit02';
      this._startingPos.y = -50;
      this._destinationPos.x = -20;
      this._destinationPos.y = -20;
    } else if (randomNumber == 2) {
      this._imagePath = 'snake_hit03';
      this._startingPos.x = -60;
      this._destinationPos.x = -30;
    }  else if (randomNumber == 3) {
      this._imagePath = 'snake_idle01';
      this._startingPos.x = -50;
      this._startingPos.y = 30;
      this._destinationPos.x = -20;
    } else if (randomNumber == 4) {
      this._imagePath = 'snake_idle02';
      this._startingPos.y = -50;
      this._destinationPos.x = -20;
      this._destinationPos.y = -20;
    } else {
      this._imagePath = 'snake_idle03';
      this._startingPos.x = -30;
    }
  } else {
    var randomNumber = Math.floor(Math.random() * 12);

    if (randomNumber == 0) {
      this._imagePath = 'dove_idle01';
      this._startingPos.y = 74;
      this._destinationPos.y = 44;
    } else if (randomNumber == 1) {
      this._imagePath = 'dove_idle02';
      this._startingPos.y = 50;
      this._destinationPos.x = -10;
      this._destinationPos.y = 20;
    } else if (randomNumber == 2) {
      this._imagePath = 'monkey_idle01';
      this._startingPos.y = 50;
      this._destinationPos.y = 20;
    } else if (randomNumber == 3) {
      this._imagePath = 'monkey_idle02';
      this._startingPos.y = 50;
      this._destinationPos.y = 20;
    } else if (randomNumber == 4) {
      this._imagePath = 'raven_idle01';
      this._startingPos.y = 74;
      this._destinationPos.y = 44;
    } else if (randomNumber == 5) {
      this._imagePath = 'raven_idle02';
      this._startingPos.y = 50;
      this._destinationPos.x = -10;
      this._destinationPos.y = 20;
    } else if (randomNumber == 6) {
      this._imagePath = 'sloth_idle01';
      this._startingPos.y = 50;
      this._destinationPos.y = 20;
    } else if (randomNumber == 7) {
      this._imagePath = 'sloth_idle02';
      this._startingPos.y = 50;
      this._destinationPos.y = 20;
    } else if (randomNumber == 8) {
      this._imagePath = 'toucan_idle01';
      this._startingPos.x = -10;
      this._startingPos.y = 90;
      this._destinationPos.y = 40;
    } else if (randomNumber == 9){
      this._imagePath = 'toucan_idle02';
      this._startingPos.y = 70;
      this._destinationPos.y = 40;
      this._destinationPos.x = -30;
    } else if (randomNumber == 10){
      this._imagePath = 'brownb_idle01';
      this._startingPos.y = 70;
      this._destinationPos.y = 15;
      this._destinationPos.x = -10;
    } else {
      this._imagePath = 'brownb_idle02';
      this._startingPos.y = -50;
      this._destinationPos.y = 0;
      this._destinationPos.x = 0;
    }
  }

  this._imageTexture = EHDI.Assets.images[this._imagePath];

  this._imageSprite = new EHDI.aka.Sprite(this._imageTexture);

  this._imageSprite.anchor.x = 0.5;
  this._imageSprite.anchor.y = 0.5;

  this.addChild(this._imageSprite);
};

EHDI.game.Animal.prototype.update = function () {
  if (!this._removed) {
    if (!this.willDisappear && !this._stopped) {
      if (this._timer.getTime() >= this._despawnDelay) {
        this.willDisappear = true;

        if (!this._isSnake) {
          this.animateOut();
          this._timer.reset();
        } else {
          this.emit('REMOVE_WARNING', this._spawnData.x, this._spawnData.y, this._isSnake);
          this._callback(this, this._tapped);
          this._removed = true;
        }

      } else if (this._isSnake && !this._warningEnable && this._timer.getTime() >= this._warningDelay) {
        this._warningEnable = true;
        this.emit('SHOW_WARNING', this);
      }
    } else if (this.willDisappear && this._timer.getTime() >= 500) {
      this._callback(this, this._tapped);
      this._removed = true;
    }
  }

  this.shakeUpdate();
};

EHDI.game.Animal.prototype.shakeUpdate = function () {
  if (this._shake) {
    if (this._shakeLeft) {
      this.x -= 2;
      if (this.x <= this._currentX - 2)
        this._shakeLeft = false;
    } else {
      this.x += 2;
      if (this.x >= this._currentX + 2)
        this._shakeLeft = true;
    }

    if (this._shakeUp) {
      this.y -= 1;
      if (this.y <= this._currentY - 2)
        this._shakeUp = false;
    } else {
      this.y += 1;
      if (this.y > this._currentY + 2)
        this._shakeUp = true;
    }
  }
}

EHDI.game.Animal.prototype.isSnake = function () {
  return this._isSnake;
}

EHDI.game.Animal.prototype.reset = function () {
  if (this._imageSprite != null)
  {
    this.removeChild(this._imageSprite);
    this._imageSprite = null;
  }

  if (this.tl1 != null) {
    this.tl1.kill();
    this.tl1 = null;
  }

  
};

EHDI.game.Animal.prototype.destroy = function () {
  
  if(this._hitbox != null)
  {
    this.removeChild(this._hitbox);
    this._hitbox.dispose();
  }
  
  if(this._timer != null)
  {
    this._timer.destroy({children: true});
  }
  delete this._timer;

  if (this._imageSprite != null)
  {
    this.removeChild(this._imageSprite);
    this._imageSprite = null;
  }

  if (this.tl1 != null) {
    this.tl1.kill();
    this.tl1 = null;
  }
  
  this._callback = null;
  this._spawnData = null;
  this._isSnake = null;
  this._startingPos = null;
  this._destinationPos = null
  this._despawnDelay = null;
  this._warningDelay = null;
  this._warningEnable = null;
  this._removed = null;
  this._tapped = null;
  this._stopped = null;
  this._shake = null;
  this._shakeLeft = null;
  this._shakeUp = null;
  this._currentX = null;
  this._currentY = null;
}

EHDI.game.Animal.prototype.pause = function () {
  this._timer.pause(true);
};

EHDI.game.Animal.prototype.resume = function () {
  this._timer.pause(false);
};

EHDI.game.Animal.prototype.getSpawnData = function () {
  return this._spawnData;
};

EHDI.game.Animal.prototype.stop = function () {
  this._stopped = true;
}

EHDI.game.Animal.prototype._handler_onTouch = function () {
  if (!this.willDisappear && !this._stopped) {
    this._tapped = true;
    this.willDisappear = true;
    if (this._isSnake) {
      this.animateOut();
    } else {
      this.shake();
    }
    this._timer.reset();
    this.emit('ANIMAL_TAPPED', this._spawnData.x, this._spawnData.y, this._isSnake);
  }
};
